var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-content section2"},[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"glasses-display",class:{'animate__show': _vm.isActive}},[_c('img',{attrs:{"src":require("../assets/glasses2.png"),"alt":"Smart Glasses Display"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }